import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { TabsModel } from '../../../models/common.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FilterStatsService } from '../../../services/filter.service';
import { SportsService } from '../../../services/sport.service';

@Component({
  selector: 'app-tab-bar',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './tab-bar.component.html',
  styleUrl: './tab-bar.component.scss',
})
export class TabBarComponent {
  @Input() filtersOptions:
    | 'dashboard'
    | 'matchDetail'
    | 'h2h'
    | 'competition'
    | 'team'
    | 'favorites'
    | 'header'
    | 'odds'
    | 'matchSummary' = 'dashboard';
  @Output() selectedIndexChange: EventEmitter<any> = new EventEmitter();
  @Input() selectedIndex: number = 0;
  @Input() optionsFilterMatch: any | null;
  @Input() filters: TabsModel[] = [];

  urlIcon = environment.urlIcon;

  hasStats = true;
  optionsFilter: Array<TabsModel> = [];
  defaultFilters: TabsModel[] = [
    {
      title: this.translateService.instant('All'),
      stats: 0,
    },
    {
      title: this.translateService.instant('InLive'),
      stats: 0,
    },
    {
      title: this.translateService.instant('Finished'),
      stats: 0,
    },
    {
      title: this.translateService.instant('Next'),
      stats: 0,
    },
  ];

  constructor(
    private readonly translateService: TranslateService,
    private readonly filterServices: FilterStatsService,
    private readonly sportsService: SportsService
  ) {}

  ngOnInit(): void {
    this.loadOptionsFilter();
  }

  loadOptionsFilter() {
    switch (this.filtersOptions) {
      case 'odds':
        this.optionsFilter = this.filters;
        break;
      case 'dashboard':
        this.optionsFilter = this.defaultFilters;
        this.changesValueTotal();
        break;
      case 'matchDetail':
        this.optionsFilter = [
          {
            title: this.translateService.instant('Match'),
          },
        ];

        if (this.sportsService.getSelectedSport() !== 'Tenis')
          this.optionsFilter = [
            ...this.optionsFilter,
            // {
            //   title: this.translateService.instant('Odds'),
            // },
            {
              title: this.translateService.instant('H2H'),
            },
            {
              title: this.translateService.instant('Standing'),
            },
          ];
        break;
      case 'h2h':
        this.optionsFilter = [
          { title: this.translateService.instant('General') },
          {
            title:
              this.optionsFilterMatch.homeTeam +
              ' - ' +
              this.translateService.instant('Home'),
          },
          {
            title:
              this.optionsFilterMatch.awayTeam +
              ' - ' +
              this.translateService.instant('Away'),
          },
        ];
        break;
      case 'competition':
        this.optionsFilter = [
          { title: this.translateService.instant('Matches') },
          { title: this.translateService.instant('Scores') },
          { title: this.translateService.instant('Standing') },
        ];
        break;
      case 'team':
        this.optionsFilter = [
          { title: this.translateService.instant('Matches') },
          { title: this.translateService.instant('Results') },
          { title: this.translateService.instant('Standing') },
          { title: this.translateService.instant('Equipment') },
        ];
        break;
      case 'favorites':
        this.optionsFilter = [
          { title: this.translateService.instant('MyCompetitions') },
          { title: this.translateService.instant('MyMatches') },
          { title: this.translateService.instant('MyTeams') },
        ];
        break;
      case 'matchSummary':
        this.optionsFilter = [
          { title: this.translateService.instant('Summary') },
          { title: this.translateService.instant('Statics') },
          { title: this.translateService.instant('Lineup') },
        ];

        this.sportsService.getSelectedSport() === 'Futbol' &&
          (this.optionsFilter = [
            ...this.optionsFilter,
            { title: this.translateService.instant('MatchInfo') },
          ]);
        break;
      case 'header':
        this.optionsFilter = [
          {
            title: this.translateService.instant('Marcadores'),
            hasIcon: 'score.png',
          },
          {
            title: this.translateService.instant('News'),
            hasIcon: 'newspaper-folded.png',
          },
        ];
        break;
      default:
        this.optionsFilter = this.defaultFilters;
        break;
    }
  }

  private changesValueTotal() {
    this.filterServices.total.subscribe((value: any) => {
      this.optionsFilter[0].stats = value;
    });

    this.filterServices.totalInLive.subscribe((value: any) => {
      this.optionsFilter[1].title = 'InLive';
      this.optionsFilter[1].stats = value;
    });

    this.filterServices.totalFinished.subscribe((value: any) => {
      this.optionsFilter[2].stats = value;
    });

    this.filterServices.totalBeginNext.subscribe((value: any) => {
      this.optionsFilter[3].stats = value;
    });
  }

  handleModelChange(index: number): void {
    this.selectedIndex = index;
    if (this.filtersOptions === 'dashboard') {
      switch (index) {
        case 0:
          this.selectedIndexChange.emit('All');
          break;
        case 1:
          this.selectedIndexChange.emit('InLive');
          break;
        case 2:
          this.selectedIndexChange.emit('Finished');
          break;
        case 3:
          this.selectedIndexChange.emit('ToBegin');
          break;
        default:
          this.selectedIndexChange.emit('All');
          break;
      }
    } else if (this.filtersOptions === 'odds')
      this.selectedIndexChange.emit(this.filters[index].title);
    else if (
      [
        'matchDetail',
        'h2h',
        'competition',
        'team',
        'favorites',
        'matchSummary',
        'header',
      ].includes(this.filtersOptions)
    )
      this.selectedIndexChange.emit(index);
  }
}
